export default "__VITE_ASSET__4cuIsRlF__"